import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import useInheritParams from 'hooks/useInheritParams';
import { Content, SamplePageNameEn } from '../../lib/FL';
import { ModalDispatchContext } from '../../contexts/ModalProvider';
import ContentPreviewModal from '../modal/ContentPreviewModal';

import styles from './TextLink.module.scss';

type ContentLinkProps = {
  content: Content;
};

const ContentTextLink: React.FC<ContentLinkProps> = ({ content, children }) => {
  const dispatch = useContext(ModalDispatchContext);
  return (
    <>
      <button
        className={`${styles.link} ${styles.link_pc}`}
        onClick={() => dispatch(() => <ContentPreviewModal content={content} />)}
        type='button'
      >
        {children}
      </button>
      <Link className={`${styles.link} ${styles.link_sp}`} to={`/content/${content.en_name}`} target='_blank'>
        {children}
      </Link>
    </>
  );
};

type DesignLinkProps = {
  business: SamplePageNameEn;
};

const DesignTextLink: React.FC<DesignLinkProps> = ({ business, children }) => {
  const { inheritParams } = useInheritParams();
  return (
    <Link
      className={styles.link}
      to={{
        pathname: `/designs/${business}`,
        search: inheritParams,
      }}
    >
      {children}
    </Link>
  );
};

const TextLink: React.FC<ContentLinkProps & DesignLinkProps> = ({ content, business, children }) =>
  content.en_name === 'top' ? (
    <DesignTextLink business={business}>{children}</DesignTextLink>
  ) : (
    <ContentTextLink content={content}>{children}</ContentTextLink>
  );

export default TextLink;
